<template>
    <router-view />
    <drawer-host />
</template>

<script setup></script>

<style></style>
